export default {
    menuList: [
        {
            name: '申请',
            id: 0,
            icon: require('../assets/image/home/apply.png'),
            // icon_h: require('../assets/image/home/answerActive.png'),
            auth: ['admin', 'teacher'],
            children: [
                {
                    path: '/homePage/mechanismOpenApply',
                    icon: require('../assets/image/home/school.png'),
                    id: 0,
                    name: '机构开通申请',
                    auth: ['teacher','admin']
                },
                {
                    path: '/homePage/mechanismPostApproval',
                    icon: require('../assets/image/home/apply2.png'),
                    id: 1,
                    name: '机构申请审批',
                    auth: ['admin']
                },
                {
                    path: '/homePage/insRegistrationView',
                    icon: require('../assets/image/home/school.png'),
                    id: 2,
                    name: '机构注册查看',
                    auth: ['admin']
                },
                {
                    path: '/homePage/websiteApproval',
                    icon: require('../assets/image/home/apply2.png'),
                    id: 3,
                    name: '官网注册审批',
                    auth: ['admin']
                },
            ]
        },
        {
            name: '计划',
            id: 1,
            icon: require('../assets/image/home/plan.png'),
            // icon_h: require('../assets/image/home/consumerActive.png'),
            auth: ['admin'],
            children: [
                {
                    path: '/homePage/applyPage',
                    icon: require('../assets/image/home/dasai.png'),
                    id: 0,
                    auth: ['admin'],
                    name: '大赛练习计划'
                },
            ]
        },
        {
            name: '管理',
            id: 2,
            auth: ['admin'],
            icon: require('../assets/image/home/manage.png'),
            // icon_h: require('../assets/image/home/homeActive.png'),
            children: [
                {
                    path: '/homePage/personManagement',
                    icon: require('../assets/image/home/person.png'),
                    id: 0,
                    auth: ['admin'],
                    name: '人员管理'
                },
                {
                    path: '/homePage/institutionalManagement',
                    icon: require('../assets/image/home/org.png'),
                    id: 1,
                    auth: ['admin'],
                    name: '机构管理'
                },
                {
                    path: '/homePage/RegWebsiteManagement',
                    icon: require('../assets/image/home/person.png'),
                    id: 2,
                    auth: ['admin'],
                    name: '报名官网管理'
                },
            ]
        },
        
    ]
}